import React from "react";
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from "react-google-maps";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import mark from "assets/img/mark.png";

// Mapa comparativo LOCAL del modulo Autorizar: dibuja los puntos recibidos
// (entrega original vs devolucion solicitada, o un solo punto en el sub-detalle
// de una entrega) con markers distinguibles (icono default vs mark.png),
// InfoWindow propio y fitBounds a todos los puntos via ref del mapa.
// NO reutiliza views/Shared/Mapa.js: su data e InfoWindow tienen shape fijo
// de Monitoreo y no deben tocarse.

const defaultLatitude = 24.2651835;
const defaultLongitude = -104.5283838;

function Map(props) {
  const { puntos } = props;

  const [selectedPunto, setSelectedPunto] = React.useState(null);

  // fitBounds a todos los puntos UNA sola vez por montaje: el ref callback se
  // dispara en cada render (los clicks del InfoWindow re-renderizan) y sin el
  // guard resetearia el zoom del usuario; el caller remonta el componente con
  // una key por solicitud/entrega, lo que cubre el cambio de solicitud.
  const ajustado = React.useRef(false);
  const onMapMounted = React.useCallback(ref => {
    if (ref && !ajustado.current && puntos.length > 1 && window.google && window.google.maps) {
      const bounds = new window.google.maps.LatLngBounds();
      puntos.forEach(function(punto) {
        bounds.extend(new window.google.maps.LatLng(punto.lat, punto.lng));
      });
      ref.fitBounds(bounds);
      ajustado.current = true;
    }
  }, []);

  if (puntos.length === 0) {
    return (
      <GoogleMap
        defaultZoom={5}
        defaultCenter={{ lat: defaultLatitude, lng: defaultLongitude }}
        defaultOptions={{ scrollwheel: false }}
      />
    );
  }

  return (
    <GoogleMap
      ref={onMapMounted}
      defaultZoom={15}
      defaultCenter={{ lat: puntos[0].lat, lng: puntos[0].lng }}
      defaultOptions={{ scrollwheel: true }}
    >
      {puntos.map((punto, key) => (
        <Marker
          key={key}
          position={{ lat: punto.lat, lng: punto.lng }}
          onClick={() => {
            setSelectedPunto(punto);
          }}
          // icono default para la entrega original, mark.png para la devolucion
          icon={punto.icono === "mark" ? { url: mark } : undefined}
        />
      ))}

      {selectedPunto && (
        <InfoWindow
          position={{ lat: selectedPunto.lat, lng: selectedPunto.lng }}
          onCloseClick={() => {
            setSelectedPunto(null);
          }}
        >
          <div>
            <p><strong>{selectedPunto.titulo}</strong></p>
            <p>{selectedPunto.lat + ", " + selectedPunto.lng}</p>
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
}

const WrappedMap = withScriptjs(withGoogleMap(Map));

// puntos: [{lat:number, lng:number, titulo:string, icono?:"mark"}] ya validados
// por el caller (se omite el marker cuando faltan coordenadas validas).
export default function MapaComparativo(props) {
  const { puntos, altura } = props;

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <WrappedMap
          puntos={puntos || []}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCPR-S0i7VwKoffK7INIx9wQFQH_ZH2a_k"
          loadingElement={<div style={{ height: "100%" }} />}
          containerElement={
            <div
              style={{
                height: altura || "350px",
                borderRadius: "6px",
                overflow: "hidden"
              }}
            />
          }
          mapElement={<div style={{ height: "100%" }} />}
        />
      </GridItem>
    </GridContainer>
  );
}
